import Vue from 'vue'
import Vuex from 'vuex'
import { get } from '@/lib/api'
import { parseStorageValue } from '@/lib/helpers'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    unitStacked: undefined,
    deposit: null,
    brands: [],
    categories: [],
    details: {},
    contact: {},
    delivery: {
      delivery_type: '',
      shippingAddress: '',
      shippingCity: '',
      shippingState: '',
      shippingZip: ''
    },
    images: [],
    settings: []
  },

  getters: {
    deliveryAddress: (state) =>  {
      if (state.delivery.delivery_type == 'on_site') {
        return ''
      } else {
        return `${state.delivery.shippingAddress} ${state.delivery.shippingCity}, ${state.delivery.shippingState} ${state.delivery.shippingZip}`
      }
    },
    getSetting: (state) => (key) => {
      return state.settings.find(setting => setting.key === key)
    },
    getCategory: (state) => (id) => {
      return state.categories.find(category => category.id === id)
    },
    getBrand: (state) => (id) => {
      return state.brands.find(category => category.id === id)
    },
  },

  mutations: {
    SET_CATEGORIES (state, payload) {
      state.categories = payload
    },
    SET_BRANDS (state, payload) {
      state.brands = payload
    },
    SET_DETAILS (state, payload) {
      localStorage.details = JSON.stringify(payload)
      state.details = payload
    },
    SET_IMAGES (state, payload) {
      state.images = payload
    },
    SET_CONTACT (state, payload) {
      localStorage.contact = JSON.stringify(payload)
      state.contact = payload
    },
    SET_DELIVERY (state, payload) {
      localStorage.delivery = JSON.stringify(payload)
      state.delivery = payload
    },
    SET_DEPOSIT (state, payload) {
      state.deposit = payload
    },
    SET_STACK (state, payload) {
      localStorage.stacked = JSON.stringify(payload)
      state.unitStacked = payload
    },
    SET_FROM_LOCAL_STORAGE (state) {
      state.details = JSON.parse(localStorage.getItem('details')) || {}
      state.contact = JSON.parse(localStorage.getItem('contact')) || {}
      state.delivery = JSON.parse(localStorage.getItem('delivery')) || {}
      state.unitStacked = parseStorageValue(localStorage.getItem('stacked'))
    },
    CLEAR_STORE (state) {
      state.unitStacked = undefined
      state.deposit = null
      state.details = {}
      state.contact = {}
      state.delivery = {}
      state.images = []
    },
    SET_SETTINGS (state, payload) {
      state.settings = payload
    }
  },

  actions: {
    SET_DETAILS_ACTION ({ commit }, payload) {
      commit('SET_DETAILS', payload.details)
      commit('SET_STACK', payload.unitStacked)
    },
    SET_IMAGES_ACTION ({ commit }, images) {
      commit('SET_IMAGES', images)
    },
    SET_CONTACT_ACTION ({ commit }, contact) {
      commit('SET_CONTACT', contact)
    },
    SET_DELIVERY_ACTION ({ commit }, delivery) {
      commit('SET_DELIVERY', delivery)
    },
    SET_DEPOSIT_ACTION ({ state, getters, commit }) {
      const category = getters.getCategory(state.details.product_category_id)
      let deposit = 0.00

      if (state.delivery.delivery_type == 'walkin') {
        deposit = parseFloat(category.on_site_deposit)
      } else {
        deposit = parseFloat(category.ship_in_deposit)
      }

      if (state.unitStacked) {
        deposit += parseFloat(category.helper_fee)
      }

      commit('SET_DEPOSIT', deposit)
    },
    CLEAR_LOCAL_STORAGE () {
      localStorage.removeItem('details')
      localStorage.removeItem('contact')
      localStorage.removeItem('delivery')
      localStorage.removeItem('stacked')
    },
    async FETCH_BRANDS({ commit }) {
      const brands = await get({ url: 'brands' })
      commit('SET_BRANDS', brands.data)
    },
    async FETCH_CATEGORIES({ commit }) {
      const categories = await get({ url: 'product_categories' })
      commit('SET_CATEGORIES', categories.data)
    },
    async FETCH_SETTINGS({commit}) {
      const settings = await get({ url: 'settings' })
      commit('SET_SETTINGS', settings.data)
    }
  }
})
